import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetOrganisationByEnterpriseIdMessages } from './messages';

export interface useGetOrganisationByEnterpriseIdOptions {
  shouldFetch?: boolean;
}

export function useGetOrganisationByEnterpriseId(
  enterpriseId: number | null | undefined,
  options?: useGetOrganisationByEnterpriseIdOptions,
) {
  const mergedOptions: useGetOrganisationByEnterpriseIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { organisationApi } = usePrivate();

  const results = useSWR(
    organisationApi && mergedOptions.shouldFetch
      ? `/api/Organisation/ByEnterpriseId/${enterpriseId}`
      : null,
    () => organisationApi?.apiOrganisationByEnterpriseIdGet(enterpriseId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetOrganisationByEnterpriseIdMessages[
            'useGetOrganisationByEnterpriseId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetOrganisationByEnterpriseId> error fetching organisation.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !organisationApi;

  return { ...results, isLoadingOrValidating };
}
